import type { Alert } from "../../types";
import { relTime } from "../../utils/format";

interface Props {
  alerts: Alert[];
  onOpen: () => void;
}

export function AlertBanner({ alerts, onOpen }: Props) {
  const crits = alerts.filter((a) => a.severity === "critical");
  if (!crits.length) return null;
  const a = crits[0];
  return (
    <div
      className="banner"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 16px",
        background:
          "linear-gradient(90deg, rgba(255,95,122,0.18), rgba(255,95,122,0.04))",
        borderBottom: "1px solid rgba(255,95,122,0.35)",
        fontSize: 12,
      }}
    >
      <span className="chip crit">
        <span className="dot pulse" /> CRITICAL · {crits.length} firing
      </span>
      <span style={{ color: "var(--fg-0)" }}>{a.summary}</span>
      <span className="u-xdim mono">· fired {relTime(a.fired_at)}</span>
      <span style={{ flex: 1 }} />
      <button className="btn xs" onClick={onOpen}>
        View all
      </button>
      <button className="btn xs ghost" onClick={onOpen}>
        Runbook ↗
      </button>
    </div>
  );
}
